import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import config from "../../config";
import useAxios from "../../utils/useAxios"; // Import the custom Axios instance

const AccountSettings = () => {
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    company_name: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
    phone_number: "",
    email: "",
    website_url: "",
    timezone: "",
    company_logo_url: "",
    favicon_url: "",
    thumbnail_url: "",
  });
  const axiosAPI = useAxios(); // Use the custom hook for Axios

  const [formImageData, setImageFormData] = useState({
    company_logo: null,
    favicon_image: null,
    thumbnail_image: null,
  });

  const [loadingImages, setLoadingImages] = useState({
    company_logo: false,
    favicon_image: false,
    thumbnail_image: false,
  });

  const fieldLabels = {
    company_logo: "Company Logo",
    favicon_image: "Favicon Image",
    thumbnail_image: "Thumbnail Image",
  };

  const company_logoInputRef = useRef(null);
  const favicon_imageInputRef = useRef(null);
  const thumbnail_imageInputRef = useRef(null);

  const fetchUserData = async () => {
    try {
      const response = await axiosAPI.get(`/api/users/get-user-details`);
      const userData = response.data;
      setFormData(userData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching ads:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle file input change and preview the selected images, and submit image
  const handleFileChange = async (e, field, field_url) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = async () => {
        // Append the file to the form data
        setImageFormData((prev) => ({
          ...prev,
          [field]: file, // Store the file object for submission
        }));
        // Append the file to the form data
        setFormData((prev) => ({
          ...prev,
          [field_url]: reader.result, // Store the base64 for preview
        }));

        setLoadingImages((prev) => ({
          ...prev,
          [field]: true, // Set loading spinner on
        }));

        const updatedFormData = new FormData();
        updatedFormData.append(field, file); // Append the changed image

        try {
          const response = await axiosAPI.put(
            `/api/users/update-user-details`,
            updatedFormData
          );

          window.notifyMessage(
            "Success",
            `${fieldLabels[field]} updated successfully!`,
            "success"
          );

          // Hide spinner after submission
          setLoadingImages((prev) => ({
            ...prev,
            [field]: false,
          }));
        } catch (error) {
          window.notifyMessage(
            "Error",
            `Error updating ${fieldLabels[field]}.`,
            "danger"
          );

          // Hide spinner after error
          setLoadingImages((prev) => ({
            ...prev,
            [field]: false,
          }));
        }
      };

      reader.readAsDataURL(file); // Read the file for preview
    }
  };

  // // Handle file input change and preview the selected images
  // const handleFileChange = (e, field, field_url) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       // Append the file to the form data
  //       setImageFormData((prev) => ({
  //         ...prev,
  //         [field]: file, // Store the file object for submission
  //         [field_url]: reader.result,
  //       }));
  //       setLoadingImages((prev) => ({
  //         ...prev,
  //         [field]: true, // Set loading spinner on
  //       }));
  //       // Call handleSubmit after updating formData
  //       handleImageSubmit(e, field); // Trigger form submission after file change
  //     };
  //     reader.readAsDataURL(file); // Read the file for preview
  //   }
  // };

  // Handle form submission to update user data
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    // Validate required fields
    if (!formData.company_name || !formData.email) {
      window.notifyMessage(
        "Error",
        "Please fill in all required fields.",
        "danger"
      );
      setIsSubmitting(false);
      return;
    }

    const updatedFormData = new FormData();

    // Loop through formData and append each value to the FormData
    for (const [key, value] of Object.entries(formData)) {
      // Skip specific fields
      if (["company_logo_url", "favicon_url", "thumbnail_url"].includes(key)) {
        continue; // Skip these fields
      }

      if (value instanceof File) {
        updatedFormData.append(key, value); // Append the file object directly
      } else {
        updatedFormData.append(key, value); // Append the regular text fields
      }
    }

    try {
      const response = await axiosAPI.put(
        `/api/users/update-user-details`,
        updatedFormData
      );

      window.notifyMessage(
        "Success",
        "Account details updated successfully!",
        "success"
      );
      setIsSubmitting(false);
    } catch (error) {
      window.notifyMessage(
        "Error",
        "Error updating account details.",
        "danger"
      );
      setIsSubmitting(false);
    }
  };

  // Handle form submission to update user data
  const handleImageSubmit = async (e, field) => {
    e.preventDefault();
    const field1 = e.target.name; // This will capture the image field name (company_logo, favicon_image, or thumbnail_image)

    console.log({ field });

    const updatedFormData = new FormData();
    const file = formImageData[field]; // Get the file for the specific image field

    if (file) {
      updatedFormData.append(field, file); // Append the changed image
    }
    console.log(file);
    console.log(updatedFormData);

    try {
      const response = await axiosAPI.put(
        `/api/users/update-user-details`,
        updatedFormData
      );

      window.notifyMessage(
        "Success",
        "Account details updated successfully!",
        "success"
      );
      setLoadingImages((prev) => ({
        ...prev,
        [field]: false, // Hide spinner after submission
      }));
    } catch (error) {
      window.notifyMessage(
        "Error",
        "Error updating account details.",
        "danger"
      );
      setLoadingImages((prev) => ({
        ...prev,
        [field]: false, // Hide spinner after error
      }));
    }
  };

  useEffect(() => {
    console.log({ formData });
  }, [formData]);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="container">
      <div className="page-inner">
        <h4 className="mt-0">Account Settings</h4>
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="card mb-4">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="card-body mb-3">
                  <div className="row">
                    {/* Company Logo */}
                    <div className="mb-3 col-md-4 text-center imgs-account-con">
                      <h6 className="fw-mediumbold mb-3">Company Logo</h6>
                      <div className="imgs-account-bs">
                        {loadingImages.company_logo ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <img
                            src={
                              formData.company_logo_url ||
                              "/assets/img/image-holder.jpg"
                            }
                            alt="company-logo"
                            className="rounded account-imgs"
                          />
                        )}
                      </div>
                      <div className="button-wrapper">
                        <label
                          htmlFor="company_logo_upload"
                          className="btn btn-light shadow-sm btn-round border mt-4 mb-4"
                        >
                          <span className="d-none d-sm-block">Change</span>
                          <i className="bx bx-upload d-block d-sm-none"></i>
                          <input
                            type="file"
                            id="company_logo_upload"
                            ref={company_logoInputRef}
                            className="account-file-input"
                            hidden
                            accept="image/png, image/jpeg"
                            onChange={(e) =>
                              handleFileChange(
                                e,
                                "company_logo",
                                "company_logo_url"
                              )
                            }
                          />
                        </label>
                      </div>
                    </div>

                    {/* Favicon Image */}
                    <div className="mb-3 col-md-4 text-center imgs-account-con">
                      <h6 className="fw-mediumbold mb-3">Favicon Image</h6>
                      <div className="imgs-account-bs">
                        {loadingImages.favicon_image ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <img
                            src={
                              formData.favicon_url ||
                              "/assets/img/image-holder.jpg"
                            }
                            alt="favicon_image"
                            className="rounded account-imgs"
                          />
                        )}
                      </div>
                      <div className="button-wrapper">
                        <label
                          htmlFor="favicon_image_file_upload"
                          className="btn btn-light shadow-sm btn-round border mt-4 mb-4"
                        >
                          <span className="d-none d-sm-block">Change</span>
                          <i className="bx bx-upload d-block d-sm-none"></i>
                          <input
                            type="file"
                            id="favicon_image_file_upload"
                            ref={favicon_imageInputRef}
                            className="account-file-input"
                            hidden
                            accept="image/png, image/jpeg"
                            onChange={(e) =>
                              handleFileChange(
                                e,
                                "favicon_image",
                                "favicon_url"
                              )
                            }
                          />
                        </label>
                      </div>
                    </div>

                    {/* Thumbnail Image */}
                    <div className="mb-3 col-md-4 text-center imgs-account-con">
                      <h6 className="fw-mediumbold mb-3">Default Thumbnail</h6>
                      <div className="imgs-account-bs">
                        {loadingImages.thumbnail_image ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary mt-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <img
                            src={
                              formData.thumbnail_url ||
                              "/assets/img/image-holder.jpg"
                            }
                            alt="default-thumbnail"
                            className="rounded account-imgs"
                          />
                        )}
                      </div>
                      <div className="button-wrapper">
                        <label
                          htmlFor="thumbnail_file_upload"
                          className="btn btn-light shadow-sm btn-round border mt-4 mb-4"
                        >
                          <span className="d-none d-sm-block">Change</span>
                          <i className="bx bx-upload d-block d-sm-none"></i>
                          <input
                            type="file"
                            id="thumbnail_file_upload"
                            ref={thumbnail_imageInputRef}
                            className="account-file-input"
                            hidden
                            accept="image/png, image/jpeg"
                            onChange={(e) =>
                              handleFileChange(
                                e,
                                "thumbnail_image",
                                "thumbnail_url"
                              )
                            }
                          />
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Form Fields */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="company_name" className="form-label">
                        Company Name
                      </label>
                      <input
                        type="text"
                        id="company_name"
                        className="form-control"
                        value={formData.company_name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="address" className="form-label">
                        Address
                      </label>
                      <input
                        type="text"
                        id="address"
                        className="form-control"
                        value={formData.address}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="city" className="form-label">
                        City
                      </label>
                      <input
                        type="text"
                        id="city"
                        className="form-control"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="state" className="form-label">
                        State
                      </label>
                      <input
                        type="text"
                        id="state"
                        className="form-control"
                        value={formData.state}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="zip_code" className="form-label">
                        Zip Code
                      </label>
                      <input
                        type="text"
                        id="zip_code"
                        className="form-control"
                        value={formData.zip_code}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="phone_number" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="text"
                        id="phone_number"
                        className="form-control"
                        value={formData.phone_number}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="website_url" className="form-label">
                        Website URL
                      </label>
                      <input
                        type="text"
                        id="website_url"
                        className="form-control"
                        value={formData.website_url}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="timezone" className="form-label">
                        Time Zone
                      </label>
                      <input
                        type="text"
                        id="timezone"
                        className="form-control"
                        value={formData.timezone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="mt-3">
                    <button
                      type="submit"
                      className="btn btn-dark btn-round me-2"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save changes"}
                    </button>
                    <button
                      type="reset"
                      className="btn btn-outline-secondary btn-round"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;
